export const PAGE_SIZE = 20;
export const TOTAL_CURRENT_REQUESTS = 4;
export const TOTAL_PAST_REQUESTS = 22;
